export const filterSectionsByTitle = (items) => {
	const wanted = [
		'Articles',
		'Dictionary',
		'GALE Resources',
		'Job Hunter',
		'Patents',
	];
	return items.filter((item) => wanted.includes(item.title));
};
